import React from 'react'
import FilterReactSelect from './FilterReactSelect';

export default function TableFilter({ company, setCompany, period, setPeriod, dataCompany, isLoadingCompany, dataPeriod, isLoadingPeriod }) {
    
    return (
        <div className='w-full flex justify-end gap-3 mb-2'>
            <div className='w-1/4 flex flex-col justify-end'>
                <FilterReactSelect 
                    defaultValue={company}
                    options={dataCompany?.data?.map(item => ({label: item.name, value: item.id}))} 
                    isLoading={isLoadingCompany} 
                    setValue={setCompany} 
                    placeholder="Pilih Perusahaan"
                />
            </div>
            <div className='w-1/4 flex flex-col justify-end'>
                <FilterReactSelect
                    defaultValue={period} 
                    options={dataPeriod?.map(item => ({label: item.name, value: item.id}))} 
                    isLoading={isLoadingPeriod} 
                    setValue={setPeriod} 
                    placeholder="Pilih Periode"
                />
            </div>
        </div>
    )
}
